import classNames from 'classnames'
import * as React from 'react'

import {BuildsWrappedPlaceholder} from '../../../../../common/Builds/Builds.wrapped'
import RowGroup from '../../../../../common/Grid/RowGroup'
import {useParentVisibility} from '../../../../../common/Visible/Visible.hooks'
import type {AgentsTreeAgentNode} from '../../../AgentsSidebar/AgentsSidebar.types'
import AgentPlaceholderListView from '../../AgentListView/AgentPlaceholderListView'

import VisibleAgent from './VisibleAgent/VisibleAgent'
import VisibleBuild from './VisibleBuild/VisibleBuild'

import styles from './AgentRow.css'

type Row = React.ComponentType<AgentsTreeAgentNode & {className?: string | null | undefined}>

const AgentRow: Row = React.memo(function AgentRow({className, ...agentNode}) {
  const parentIsVisible = useParentVisibility()

  return (
    <>
      <RowGroup>
        {parentIsVisible ? (
          <VisibleAgent className={classNames(className, styles.agent)} {...agentNode} />
        ) : (
          <AgentPlaceholderListView
            className={classNames(className, styles.agent)}
            {...agentNode}
          />
        )}
      </RowGroup>
      {agentNode.buildId != null &&
        (parentIsVisible ? (
          <VisibleBuild buildId={agentNode.buildId} hasParentGrid />
        ) : (
          <BuildsWrappedPlaceholder hasParentGrid />
        ))}
    </>
  )
})

export default AgentRow
